import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import LinearProgressWithLabel from './LinearProgressWithLabel';
import playerStore from '../../stores/player';
import { useEffect } from 'react';

function PlayerLinearProgressWithLabel(props) {

  const currentBuffer = playerStore((state) => state.currentBuffer);
  const currentTime = playerStore((state) => state.currentTime);
  const iosFrom = playerStore((state) => state.iosFrom);
  const currentTrack = playerStore((state) => state.currentTrack);

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const toMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const currentProgress = (curTime) => {
    if (currentTrack && currentTrack.length) {
      return (curTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  const renderProgressLine = () => {
    console.log("renderProgressLine")
    if (playerStore.getState().iosFrom?.from && playerStore.getState().iosFrom?.from != 0) {
      console.log("use currentTime iosFrom", playerStore.getState().iosFrom?.from)
      return <LinearProgressWithLabel currentTime={toMMSS(playerStore.getState().iosFrom.from)} value={currentProgress(playerStore.getState().iosFrom.from)} buffer={currentBuffer * 100} length={getLength(currentTrack)} onProgressClick={props.onProgressClick} />
    } else {
      console.log("use currentTime std")
      return <LinearProgressWithLabel currentTime={toMMSS(currentTime)} value={currentProgress(currentTime)} buffer={currentBuffer * 100} length={getLength(currentTrack)} onProgressClick={props.onProgressClick} />
    }
  };

  return (
    <>
      {renderProgressLine()}
    </>
  );
}

export default PlayerLinearProgressWithLabel;